<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import * as apisPortal from '/@src/client-portal/api'
import useAuth from '/@src/composable/useAuth'
import * as useFeatureFlags from '/@src/composable/useFeatureFlags'
import { useUserSession } from '/@src/stores/userSession'

const portalApi = new apisPortal.PortalAuthApi()
const { t } = useI18n()
const { user, loading, isLoggedIn, logoutUser } = useUserSession()

const { logout } = useAuth()
let locationURL = location.protocol + '//' + location.host

const loginForm = async () => {
  try {
    const response = await portalApi.loginPortalAuth(locationURL + '/callback')
    window.location.replace(response.data.url!)
  } catch (error: any) {}
}
const moveToRegistration = async () => {
  try {
    const response = await portalApi.registerPortalAuth(locationURL + '/callback')
    window.location.replace(response.data.url!)
  } catch (error: any) {}
}

const doLogout = async () => {
  logoutUser()
  logout()
}
</script>
<template>
  <UserPanel v-if="!!isLoggedIn" :user="user" @logout="doLogout" />
  <div v-else>
    <IDSKButton
      v-if="
        useFeatureFlags.isFeatureFlag(
          useFeatureFlags.FeatureFlags.PORTAL_REGISTRACIA_TLACIDLO
        )
      "
      variant="primary"
      data-test-id="prihlasenie-registracia"
      @click="moveToRegistration()"
      >{{ t('pouzivatel.registracia') }}</IDSKButton
    >

    <template
      v-if="
        useFeatureFlags.isFeatureFlag(
          useFeatureFlags.FeatureFlags.PORTAL_PRIHLASENIE_TLACIDLO
        )
      "
    >
      <IDSKButton
        variant="secondary"
        data-test-id="prihlasenie-prihlasit"
        @click="loginForm()"
        >{{ t('pouzivatel.prihlasenie') }}</IDSKButton
      >
    </template>
  </div>
</template>

<style lang="scss">
.idsk-button {
  margin-right: 16px;
}
</style>
